import InputWithButton from "../../components/common/interactive/InputWithButton"

import classes from './HeaderSearchBox.module.css'

import { useDispatch, useSelector } from "react-redux"
import { searchActions } from "../../store/search"
import SearchResults from "./SearchResults"
import { useEffect, useRef, useState } from "react"
import { flexibleSearchPatientCompound, searchPatientByName } from "../../lib/fetchApi"
import OutsideClickComponent from "../../components/fragments/OutsideClickComponent"
import { detailedSearchOptions } from "../../assets/data"
import ReactDOM from "react-dom"
import Backdrop from "../../components/common/modal/Backdrop"
import { searchGetTypeOfValue } from "../../lib/misc"

const INCLUDE_ARCHIVED_OPTION = detailedSearchOptions.find((item) => item.apiProp === 'include_archived')

const isSuccessfulPatientSearchResults = (search) => Array.isArray(search) && search.length > 0

const buildCompoundQueryString = (compoundSearchDirect, searchTerm) => {
    let string = ''
    compoundSearchDirect.forEach((item) => {
        if (string) {
            string = `${string}&${item.value}${searchTerm}`
        } else {
            string = `${item.value}${searchTerm}`
        }
    })
    return string
}

const HeaderSearchBox = () => {
    const formRef = useRef(null)
    const dispatch = useDispatch()
    const [searchLoading, setSearchLoading] = useState(false)
    const [showSearchResults, setShowSearchResults] = useState(false)
    const [searchedText, setSearchedText] = useState(null)

    const [detailedSearch, setDetailedSearch] = useState(null)

    const [compoundSearch, setCompoundSearch] = useState([])

    const [triggerSearch, setTriggerSearch] = useState(0)

    const [overideSearch, setOverideSearch] = useState(false)
    const [resetInputSignal, setResetInputSignal] = useState(0)
    const [searchScope, setSearchScope] = useState(null)

    const userToken = useSelector(state => state.user.token)
    const showSearchPanel = showSearchResults && searchedText && searchScope !== null

    const searchPatientHandler = async (event, directData = null) => {
        let data = directData ? directData : null
        if (event) {
            event.preventDefault()
            const fd = new FormData(event.target)

            data = Object.fromEntries(fd.entries())
        }
        setSearchLoading(true)

        let compoundSearchDirect = [...compoundSearch]


        let type = searchGetTypeOfValue(data.header_search, compoundSearchDirect)

        if (type && !overideSearch) {

            const includeArchived = compoundSearchDirect.find(item => item && item.apiProp === 'include_archived');
            if (includeArchived) {
                compoundSearchDirect = [...type, includeArchived];
            } else {
                compoundSearchDirect = [...type];
            }

            setCompoundSearch(compoundSearchDirect)
        }
        setOverideSearch(false)

        if (data.header_search !== '') {
            const includeArchivedSelected = compoundSearchDirect.some(
                (item) => item?.apiProp === 'include_archived'
            )
            let search
            let scope = null

            const selectIncludeArchivedToggle = () => {
                if (!INCLUDE_ARCHIVED_OPTION) {
                    return
                }
                setCompoundSearch((prev) => {
                    if (prev.some((el) => el.apiProp === 'include_archived')) {
                        return prev
                    }
                    return [...prev, INCLUDE_ARCHIVED_OPTION]
                })
            }

            if (!compoundSearchDirect || compoundSearchDirect.length === 0) {
                search = await searchPatientByName(userToken, data.header_search)

                if (search?.errorMessage) {
                    scope = null
                } else if (!isSuccessfulPatientSearchResults(search)) {
                    search = await flexibleSearchPatientCompound(
                        userToken,
                        `search=${data.header_search}&include_archived=1`
                    )

                    if (search?.errorMessage) {
                        scope = null
                    } else if (isSuccessfulPatientSearchResults(search)) {
                        scope = 'archived_fallback'
                        selectIncludeArchivedToggle()
                    } else {
                        scope = 'empty'
                    }
                } else {
                    scope = 'active'
                }
            } else {
                const queryString = buildCompoundQueryString(compoundSearchDirect, data.header_search)
                search = await flexibleSearchPatientCompound(userToken, queryString)

                if (search?.errorMessage) {
                    scope = null
                } else if (includeArchivedSelected) {
                    scope = isSuccessfulPatientSearchResults(search) ? 'archived_manual' : 'empty'
                } else if (!isSuccessfulPatientSearchResults(search)) {
                    search = await flexibleSearchPatientCompound(
                        userToken,
                        `${queryString}&include_archived=1`
                    )

                    if (search?.errorMessage) {
                        scope = null
                    } else if (isSuccessfulPatientSearchResults(search)) {
                        scope = 'archived_fallback'
                        selectIncludeArchivedToggle()
                    } else {
                        scope = 'empty'
                    }
                } else {
                    scope = 'active'
                }
            }

            dispatch(searchActions.setSearchResults(search))
            setSearchScope(scope)
            setSearchedText(data.header_search)
            setShowSearchResults(true)
        } else {
            dispatch(searchActions.setSearchResults(null))
            setSearchScope(null)
        }

        if (event) {
            event.target.reset()
        }
        setSearchLoading(false)
    }

    const clearSearchhandler = () => {
        setSearchedText(null)
        setSearchScope(null)
        dispatch(searchActions.setSearchResults(null))
    }

    const setDetailedSearchOption = (value) => {

        let arr = [...compoundSearch]

        const index = arr.findIndex(object => {
            return object.value == value.value
        })

        if (index !== -1) {
            arr.splice(index, 1)
            setCompoundSearch(arr)
        } else {
            setCompoundSearch(prevState => prevState = [...prevState, value])
        }
        setOverideSearch(true)
        setTriggerSearch(prevState => prevState + 1)

    }

    const removeFilterHandler = () => {
        setDetailedSearch(null)
    }

    function hideResultsHandler() {
        setShowSearchResults(false)
    }

    const handlePatientSelected = () => {
        setShowSearchResults(false)
        setSearchedText(null)
        setSearchScope(null)
        dispatch(searchActions.setSearchResults(null))
        setResetInputSignal(prev => prev + 1)
    }
    function showResultsHandler() {
        setShowSearchResults(true)
    }

    const keepSearchFocus = (e) => {
        e.preventDefault()
    }

    const handleOutsideClick = () => {
        if (showSearchResults) {
            hideResultsHandler()
        }
    }

    useEffect(() => {
        if (searchedText) {
            formRef.current?.requestSubmit()
        }

    }, [triggerSearch])

    const searchContainer = (
        <div className={`${classes.header_search_container} ${showSearchResults ? classes.header_search_container_active : ''}`}>
            <div className={classes.header_search_container_inner}>
                <form ref={formRef} className={classes.header_search_form} onSubmit={searchPatientHandler}>
                    <InputWithButton
                        label="Search"
                        type="text"
                        name="header_search"
                        required={false}
                        placeholder=""
                        buttonIcon="ti ti-search"
                        clearInputExtraTask={clearSearchhandler}
                        isLoading={searchLoading}
                        foucsExtraTask={showResultsHandler}
                        actionOnKeyUp={true}
                        interruptActionOnKeyUpOnEnter={true}
                        resetSignal={resetInputSignal}
                    />
                </form>
            </div>
            {showSearchResults && (
                <div
                    className={classes.detailed_search_container}
                    onMouseDown={keepSearchFocus}
                >
                    <h4>Search by:</h4>
                    <div className={classes.detailed_search_buttons}>
                        {detailedSearchOptions && detailedSearchOptions.map(item => (
                            <button
                                key={item.label}
                                onClick={() => { setDetailedSearchOption({ ...item, forced: true }) }}
                                className={`${compoundSearch.some(el => el.value == item.value) ? classes.option_selected : ''} ${item.separated ? classes.option_separated : ''}`}
                            >
                                {item.label}
                            </button>
                        ))}
                    </div>
                </div>
            )}
            {detailedSearch && (
                <div className={classes.filter_container}>
                    You are searching in:
                    <div className={classes.filter_container_term}>{detailedSearch.label} </div>
                    <button onClick={removeFilterHandler} title="Remove Filter" className={classes.remove_filter_button}><i className="ti ti-x"></i></button>
                </div>
            )}
            {showSearchResults && (
                <SearchResults
                    searchedText={searchedText}
                    searchScope={searchScope}
                    hideResults={handlePatientSelected}
                    onPanelMouseDown={keepSearchFocus}
                />
            )}
        </div>
    )

    return <>
        <OutsideClickComponent task={handleOutsideClick} className={classes.search_outside_wrapper}>
            {searchContainer}
        </OutsideClickComponent>

        {/* Full-screen backdrop only when the results list is open — not on mere focus (otherwise it blocks header nav e.g. Queues). */}
        {showSearchPanel && (
            <>
                {ReactDOM.createPortal(
                    <Backdrop hide={hideResultsHandler} hideEnabled={true} underHeader={true} />,
                    document.getElementById("backdrop-root"),
                )}
            </>
        )}
    </>
}

export default HeaderSearchBox
